import { Address, addressToMultilineAddress, orUndefined } from '@aloft/toolkit-shared';
import { CopyButton, Flex, Typography } from '@aloft/toolkit-sui';

type ValuationTablePropertyHeaderAddressProps = {
  address: Address;
};

export const ValuationTablePropertyHeaderAddress = ({
  address,
}: ValuationTablePropertyHeaderAddressProps) => {
  const [addressLine1, addressLine2] = orUndefined(addressToMultilineAddress)(address) ?? ['', ''];

  return (
    <Flex gap="16px" justifyContent="flex-start" alignItems="center">
      <Flex flexDirection="column" lineHeight="1.3" overflow="hidden" whiteSpace="nowrap">
        <Typography variant="subtitle1" truncate color="textTertiary" textAlign="left">
          {addressLine1}
        </Typography>
        <Typography variant="subtitle1" truncate color="textTertiary" textAlign="left">
          {addressLine2}
        </Typography>
      </Flex>
      <CopyButton value={`${addressLine1} ${addressLine2}`} />
    </Flex>
  );
};
